export interface AnimalImage {
  image_url: string;
  thumbnail_url?: string;
  source_image_url?: string;
  source_page_url?: string;
  source_name?: string;
  license?: string;
  creator?: string;
  attribution?: string;
  alt_text?: string;
  position?: number;
  focal_x?: number | null;
  focal_y?: number | null;
}

export interface AnimalSource {
  name: string;
  url: string;
  source_type?: string;
  title?: string;
  is_primary?: boolean;
}

export interface RelatedAnimal {
  slug: string;
  common_name: string;
  relation_type?: string;
}

export interface AnimalRecord {
  slug: string;
  common_name: string;
  scientific_name: string;
  animal_type: string;
  summary: string;
  habitat: string;
  diet: string;
  lifespan: string;
  weight: string;
  length: string;
  geographic_range: string;
  conservation_status: string;
  images: AnimalImage[];
  sources: AnimalSource[];
  related_animals: RelatedAnimal[];
  is_verified: boolean;
}

export interface AnimalResolveResponse {
  matched: boolean;
  animal: AnimalRecord | null;
}

const ANIMAL_RESOLVE_API_URL =
  "https://api.ayesearch.com/api/animals/resolve/";

export async function resolveAnimal(
  query: string,
): Promise<AnimalResolveResponse> {
  const url = new URL(ANIMAL_RESOLVE_API_URL);
  url.searchParams.set("q", query);

  const response = await fetch(url.toString(), {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Animal resolver returned HTTP ${response.status}`);
  }

  const data = (await response.json()) as AnimalResolveResponse;

  return {
    matched: data?.matched === true && !!data.animal,
    animal: data?.animal || null,
  };
}
